<template>
    <div class="container" style="margin-top: 90px;">
        <h4 class="d-flex justify-content-center"><b style="color: green;">CANDIDATE LIST</b></h4>
        <div class="d-flex flex-wrap text-start px-4 pt-2">
            <h5 class="me-3 ">
                <b>Faculty/Institute/Directorate/Center:</b>
            </h5>
            <select id="faculty" name="faculty" v-model="faculty" @change="listCandidates(faculty)">
                <option value="Agriculture" selected>Agriculture</option>
                <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                <option value="Clinical Sciences">Clinical Sciences</option>
                <option value="Medical Laboratory Science">Medical Laboratory Science</option>
                <option value="Communication and Media Studies">Communication and Media Studies</option>
                <option value="Engineering">Engineering</option>
                <option value="Education">Education</option>
                <option value="Environmental Sciences">Environmental Sciences</option>
                <option value="Humanities">Humanities</option>
                <option value="Law">Law</option>
                <option value="Administration and Management">Administration and Management</option>
                <option value="Science">Science</option>
                <option value="Insitute of Education">Institute of Education</option>
                <option value="Rivers Institute of Agricultural Research & Training">Rivers Institute of Agricultural Research & Training</option>
                <option value="Centre for Open and Distance Learning">Centre for Open and Distance Learning</option>
                <option value="Institute Of Geo-sciences And Environmental Management">Institute Of Geo-sciences And Environmental Management</option>
                <option value="Institute of Pollution Studies">Institute of Pollution Studies</option>
                <option value="Centre for Climate Change & Forest Resources">Social Sciences</option>
                <option value="Centre for Advance Law Research">Centre for Advance Law Research</option>
                <option value="Centre for Water & Sanitation Studies">Centre for Water & Sanitation Studies</option>
                <option value="Advancement and Linkage Centre profile">Advancement and Linkage Centre profile</option>
                <option value="Centre for Continuing Education">Centre for Continuing Education</option>
                <option value="Centre Of Excellence In Marine Offshore Engineering">Centre Of Excellence In Marine Offshore Engineering</option>
                <option value="Information and Communication Technology Centre (ICTC)">Information and Communication Technology Centre (ICTC)</option>
                <option value="Directorate of Alumni Relations">Directorate of Alumni Relations</option>
                <option value="Directorate of Physical Planning">Directorate of Physical Planning</option>
                <option value="Directorate of Research and Development">Directorate of Research and Development</option>
                <option value="Directorate of Pre-Degree Programme">Directorate of Pre-Degree Programme</option>
                <option value="Directorate of Establishment">Directorate of Establishment</option>
                <option value="Directorate of Students Affairs">Directorate of Students Affairs</option>
                <option value="Directorate of Quality Assurance">Directorate of Quality Assurance</option>
                <option value="Directorate of Academic Planning">Directorate of Academic Planning</option>
                <option value="University Library">University Library</option>
                <option value="Consultancy Services Unit">Consultancy Services Unit</option>
                <option value="Guidiance and Counselling Unit">Social Sciences</option>
                <option value="Foundation Studies Unit">Foundation Studies Unit</option>
                <option value="Medical Centre">Medical Centre</option>
                <option value="Information/Publication/Protocol Unit">Information/Publication/Protocol Unit</option>
                <option value="Intellectual Property and Technology Transfer Office">Intellectual Property and Technology Transfer Office</option>
                <option value="The Registry">The Registry</option>
                <option value="Students' Industrial Work Experience Scheme (SIWES) Unit">Students' Industrial Work Experience Scheme (SIWES) Unit</option>
                <option value="University Security Unit">University Security Unit</option>
                <option value="Estate, Works and Transport">Estate, Works and Transport</option>
                <option value="Others">Others</option>
            </select>
        </div>
        <div v-if="candidates.length > 0" class="my-3 container mx-3">
            <h4 class="text-start" style="color: grey;"><b>Non-academic Staff</b></h4>
            <div  class="mt-2 text-start">
                <h5><b>Candidates to Appraise:</b></h5>
                <h6 class="names" v-for="candidate, candidateIndex in candidates">
                    <router-link :to="'/nonacademiccandidate/' + candidate._id">
                        ({{ candidateIndex + 1 }}) {{ candidate.name }}
                    </router-link>
                </h6>
            </div>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'nonacademiccandidatelist',
    emits: ['toggleLoader'],
    data() {
        return {
            faculty: '',
            candidates: [],
            loadingPage: false
        }
    },
    methods: {
        async listCandidates(faculty) {
            this.$emit('toggleLoader');

            const candidates = await DataService.getNonacademicCandidates();

            if (candidates) {
                this.candidates = candidates.filter(candidate => candidate.submittedDoc ? candidate.submittedDoc.faculty == faculty : false)
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>